import ComicCard from '@/components/base/ComicCard';
import { comics } from '@/mocks/comics';

export default function HotRecommend() {
  const featuredComics = comics.filter((c) => c.featured);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-2">
              精选高分韩漫，大家都在看的热门作品
            </p>
          </div>
          <a
            href="/category/all"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5">
          {featuredComics.map((comic) => (
            <ComicCard
              key={comic.id}
              id={comic.id}
              title={comic.title}
              author={comic.author}
              cover={comic.cover}
              categoryName={comic.categoryName}
              categorySlug={comic.category}
              rating={comic.rating}
              views={comic.views}
              chapters={comic.chapters}
              status={comic.status}
              updatedAt={comic.updatedAt}
            />
          ))}
        </div>
      </div>
    </section>
  );
}